import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import { SentimentReportTypeEnum } from '../../../../common/enum/sentiment/sentiment-report-type.enum';

export interface SelfSentimentReportTimeSeriesEntityProps {
  localDate: Date;
  reportType: SentimentReportTypeEnum;
  score: Number;
  count: Number;
}

export class SelfSentimentReportTimeSeriesEntity extends Entity<SelfSentimentReportTimeSeriesEntityProps> {
  protected _id: string;
  static create(
    props: SelfSentimentReportTimeSeriesEntityProps,
    entityId?: string
  ): SelfSentimentReportTimeSeriesEntity {
    const id = entityId || v4();
    const entity = new SelfSentimentReportTimeSeriesEntity({
      id,
      props,
    });
    return entity;
  }
  public validate(): void {}

  get localDate(): Date {
    return new Date(this.props.localDate.setUTCHours(0, 0, 0, 0));
  }
  get reportType(): SentimentReportTypeEnum {
    return this.props.reportType;
  }
  get score(): Number {
    return this.props.score;
  }
  get count(): Number {
    return this.props.count;
  }
  get percentageOfTotal(): Number {
    return 100;
  }
}
